module.exports = __webpack_public_path__ + "static/media/yourspace2.a2e13689.png";